import styled from 'styled-components'

const ReportSummaryItem = styled.div`
  flex: auto;
`

export default ReportSummaryItem